<template>
    <hh-btn class="add-remove-button"
            :text="displayText"
            :disabled="disabled"
            :type="buttonType"
            @click="handleClick" />
</template>

<script>

import BreakpointTracker from '@/components/breakpoint-tracker'

export default {
    mixins: [
        BreakpointTracker,
    ],

    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        isAdded: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        displayText() {
            if (this.activeBreakpoint === 'small')
                return this.isAdded ? 'Remove' : 'Add'

            return this.isAdded ? 'Remove from Basket' : 'Add to Basket'
        },

        buttonType() {
            return this.isAdded ? 'warning' : 'primary'
        },
    },

    methods: {
        handleClick() {
            this.$emit(this.isAdded ? 'remove' : 'add')
        },
    },
}

</script>

<style lang="scss">

.add-remove-button {
    margin-top: 0 !important;

    @include bp-min-mid {
        width: 200px;
    }
}

</style>
